"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createRandomString = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _preactCompat = require("preact-compat");

var _typeGuards = require("../../libs/typeGuards");

var _Warning = _interopRequireDefault(require("@insided/shared/icons/Warning"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var createRandomString = function createRandomString(length) {
  var str = '';

  while (str.length < length) {
    str += Math.random().toString(36).substr(2);
  }

  return str;
};

exports.createRandomString = createRandomString;

var InputGroup = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(InputGroup, _PureComponent);

  var _super = _createSuper(InputGroup);

  function InputGroup(props) {
    var _props$id;

    var _this;

    (0, _classCallCheck2.default)(this, InputGroup);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "randomId", void 0);
    _this.randomId = (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : createRandomString(8);
    return _this;
  }

  (0, _createClass2.default)(InputGroup, [{
    key: "render",
    value: function render() {
      var _ref, _props$customInput, _props$qaClasses;

      var props = this.props;
      var restriction = typeof props.maxlength !== 'undefined' && !props.newStyle ? (0, _preact.h)("span", {
        className: "restriction pull-right"
      }, "Max. ", props.maxlength, " characters") : null;
      var charactersLeft = props.showCharactersLeft && typeof props.max !== 'undefined' ? (0, _preact.h)("span", {
        className: "characters-left pull-right"
      }, props.max - props.value.length, " characters left") : null;
      var addErrorStyleToInput = (_ref = props.error && props.error !== '') !== null && _ref !== void 0 ? _ref : props.hasError;
      var input = (_props$customInput = props.customInput) !== null && _props$customInput !== void 0 ? _props$customInput : props.children;
      return (0, _preact.h)("div", {
        key: props.key,
        className: (0, _classnames.default)(props.formGroupClasses, 'form-group', props.newStyle && 'form-group--new-style'),
        "data-value": props.value
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)({
          inline: props.inline
        })
      }, (0, _preact.h)("label", {
        htmlFor: this.randomId,
        className: props.title ? undefined : 'hide-label'
      }, props.title), props.optional ? ' (optional)' : null, restriction, charactersLeft, props.meta ? (0, _preact.h)("p", {
        className: props.newStyle ? 'input-label-meta-text' : ''
      }, props.meta) : null, props.disclaimer, input !== null && input !== void 0 ? input : (0, _preact.h)("input", {
        className: "form-control ".concat((_props$qaClasses = props.qaClasses) !== null && _props$qaClasses !== void 0 ? _props$qaClasses : '', " ").concat(addErrorStyleToInput ? 'validation-error' : ''),
        type: props.type,
        id: this.randomId,
        value: props.value,
        checked: !!props.checked,
        name: props.name,
        min: props.min,
        max: props.max,
        onBlur: props.onBlur,
        onChange: function onChange(e) {
          if (props.onChange && (0, _typeGuards.hasValueInEventTarget)(e)) {
            props.onChange(e);
          }

          if (props.onChangeCallback && (0, _typeGuards.hasValueInEventTarget)(e)) {
            props.onChangeCallback(e);
          }
        },
        onClick: function onClick(e) {
          if (props.onChangeCheckbox && (0, _typeGuards.isInputClickEvent)(e)) {
            props.onChangeCheckbox(e);
            return;
          }

          if (props.onClick && (0, _typeGuards.isInputClickEvent)(e)) {
            props.onClick();
          }
        },
        onKeyUp: props.onKeyUp,
        onInput: function onInput(e) {
          if (props.onInput && (0, _typeGuards.hasValueInEventTarget)(e)) {
            props.onInput(e);
          }
        },
        required: props.required,
        disabled: props.disabled,
        readOnly: !!props.readOnly,
        maxLength: props.maxlength,
        placeholder: props.placeholder,
        pattern: props.pattern
      })), props.error && props.error !== '' ? (0, _preact.h)("div", {
        className: "validation-error error-message"
      }, props.showIconBeforeErrorMessage && (0, _preact.h)(_Warning.default, {
        className: "icon-warning"
      }), (0, _preact.h)("span", {
        className: "error-message-text"
      }, props.error)) : null);
    }
  }]);
  return InputGroup;
}(_preactCompat.PureComponent);

var _default = InputGroup;
exports.default = _default;